<div id="splash-screen">
  <h4>{{ 'common.splashLoading' | translate }}</h4>
  <pps-load-indicator [size]="60" class="loader" />
</div>
